import { Box, Button, Stack, Typography } from "@mui/material";
import CircledBackButton from "@/features/Common/components/CircledBackButton";
import IconLoader from "@/features/Common/components/IconLoader";

export interface ScreenWrapperProps {
  onBack: () => void;
  title: string;
  description?: string;
  onInfoClick?: () => void;
  children: React.ReactNode;
}

export default function ScreenWrapper({
  onBack,
  title,
  description,
  onInfoClick,
  children,
}: ScreenWrapperProps): JSX.Element {
  return (
    <Stack
      p={2}
      sx={{ height: "100%", display: "flex", flexDirection: "column" }}
    >
      <Box
        component="header"
        sx={{
          display: "flex",
          alignItems: "center",
          mb: 1,
        }}
      >
        <CircledBackButton onClick={onBack} showLabel={true} />
      </Box>

      <Stack width="100%" mt={2}>
        <Stack
          flexDirection="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography
            fontWeight={600}
            variant="h3"
            sx={{
              fontWeight: 700,
              fontSize: 26,
              lineHeight: 1.25,
            }}
          >
            {title}
          </Typography>
          {onInfoClick != null && (
            <Button
              variant="text"
              onClick={onInfoClick}
              aria-label="More information"
              style={{
                padding: 0,
                margin: 0,
                minWidth: "auto",
              }}
            >
              <IconLoader icon="InfoIcon" color="primary" />
            </Button>
          )}
        </Stack>
        {description != null && description !== "" && (
          <Stack mt={1}>
            <Typography
              sx={{
                fontSize: 16,
                fontWeight: 500,
                lineHeight: 1.5,
                color: "neutral.700",
              }}
            >
              {description}
            </Typography>
          </Stack>
        )}
      </Stack>

      <Box sx={{ flex: 1, mt: 3 }}>{children}</Box>
    </Stack>
  );
}
